export const getMortgageFlow = () => {
  return {
    languageChoice: {
      question: null, // Will use translation
      field: 'languageChoice',
      next: 'firstName'
    },
    firstName: {
      question: null,
      field: 'firstName',
      next: 'lastName'
    },
    lastName: {
      question: null,
      field: 'lastName',
      next: 'middleName'
    },
    middleName: {
      question: null,
      field: 'middleName',
      next: 'email'
    },
    email: {
      question: "Great! What's your email address?",
      field: 'email',
      next: 'phone'
    },
    phone: {
      question: "Perfect! What's your phone number?",
      field: 'phone',
      next: 'dateOfBirth'
    },
    dateOfBirth: {
      question: "What's your date of birth?",
      field: 'dateOfBirth',
      next: 'currentAddress'
    },
    currentAddress: {
      question: "Great! Now I need to know your current address. Please provide the full address including street, city, state, and ZIP code.",
      field: 'currentAddress',
      next: 'timeAtAddress'
    },
    timeAtAddress: {
      question: "Perfect! How long have you been living at your current address? Please tell me in years and months (for example: 2 years 6 months, or just 1 year, or 8 months).",
      field: 'timeAtAddress',
      next: 'housingStatus'
    },
    housingStatus: {
      question: "Thanks for that information! Now, do you currently rent or own your home?",
      field: 'housingStatus',
      next: 'monthlyPayment'
    },
    monthlyPayment: {
      question: "I understand. Could you tell me what your current monthly housing payment is?",
      field: 'monthlyPayment',
      next: 'employer'
    },
    employer: {
      question: "Thank you for that. Now let's talk about your employment. Who is your current employer?",
      field: 'employer',
      next: 'jobTitle'
    },
    jobTitle: {
      question: "Great! And what is your job title or position at that company?",
      field: 'jobTitle',
      next: 'employmentType'
    },
    employmentType: {
      question: "Perfect! Now I need to know about your employment type. How do you receive your income? Please choose from the following options:\n\n• W-2 Employee (traditional employee with taxes withheld)\n• 1099 Contractor/Self-employed (independent contractor)\n• Other\n\nPlease let me know which option applies to you.",
      field: 'employmentType',
      next: 'employmentLength'
    },
    employmentLength: {
      question: "Excellent! How long have you been working with your current employer? Please tell me in years and months (for example: 3 years 2 months, or just 2 years, or 10 months).",
      field: 'employmentLength',
      next: 'annualIncome'
    },
    annualIncome: {
      question: "Perfect! Now I need to know about your income. What is your gross annual income before taxes?",
      field: 'annualIncome',
      next: 'otherIncome'
    },
    otherIncome: {
      question: "Great! Do you have any additional sources of income besides your main job? This could include freelance work, rental income, investments, etc. If yes, please describe and provide the monthly amount. If no, just type 'None'.",
      field: 'otherIncome',
      next: 'purchasePrice'
    },
    purchasePrice: {
      question: "How much would you like to buy a house for?",
      field: 'purchasePrice',
      next: 'loanPurpose'
    },
    loanPurpose: {
      question: "Perfect! Now I need to understand the purpose of your loan. Please choose from the following options:\n\n• Purchase a new home\n• Refinance an existing mortgage\n• Construction loan\n• Home renovation/improvement\n• Other\n\nPlease let me know which option applies to you.",
      field: 'loanPurpose',
      next: 'propertyType'
    },
    propertyType: {
      question: "Great! Now I need to know about the type of property you're interested in. What kind of home are you looking to finance? Please choose from the following options:\n\n• Single Family Home\n• Condominium\n• Townhouse\n• Multi-family Property (2-4 units)\n• Manufactured/Mobile Home\n• Other\n\nPlease let me know which type best describes your property.",
      field: 'propertyType',
      next: 'occupancy'
    },
    occupancy: {
      question: "Perfect! Now I need to know how you plan to use this property. This affects your loan terms and interest rates. Please choose from the following options:\n\n• Primary Residence (your main home where you'll live most of the time)\n• Secondary Home (vacation home or weekend retreat that you'll use occasionally)\n• Investment Property (rental property to generate income)\n\nWhich option best describes how you'll use this property?",
      field: 'occupancy',
      next: 'creditScore'
    },
    creditScore: {
      question: "Great! Now I need to know about your credit score, which helps determine your loan terms and interest rates. Credit scores typically range from 300-850. Here's a quick guide:\n\n• Excellent: 750-850 (best rates available)\n• Good: 700-749 (favorable rates)\n• Fair: 650-699 (moderate rates)\n• Poor: 300-649 (higher rates, may need special programs)\n\nWhat is your approximate credit score? If you don't know, just type 'Unknown' and we can help you check it later.",
      field: 'creditScore',
      next: 'citizenshipStatus'
    },
    citizenshipStatus: {
      question: "What's your citizenship status? Please choose from the following options:\n\n• US Citizen\n• Permanent Resident\n• Non-Permanent Resident\n• Other\n\nPlease let me know which option applies to you.",
      field: 'citizenshipStatus',
      next: 'taxReturns'
    },
    taxReturns: {
      question: "Finally, please email ALL PAGES of your tax returns for the last 2 years to Zarema Ergeshova, your mortgage consultant, at z.ergeshova@mottomortgage.com. Just type 'I will email them' to confirm you understand.",
      field: 'taxReturns',
      next: 'complete'
    },
    complete: {
      question: "Congratulations! 🎉 I have collected all the necessary information, and your mortgage consultant will review your application and contact you within 24-48 hours with next steps. Thank you for choosing us for your home financing needs - we're excited to help you achieve your homeownership dreams!",
      field: null,
      next: null
    }
  };
};

export const getProgressInfo = (currentStep) => {
  const flow = getMortgageFlow();
  const steps = Object.keys(flow).filter(step => step !== 'complete');
  const totalSteps = steps.length;
  
  // If application is complete, show 100%
  if (currentStep === 'complete') {
    return {
      currentStep: totalSteps,
      totalSteps,
      percentage: 100
    };
  }
  
  const currentStepIndex = steps.indexOf(currentStep);
  const currentStepNumber = currentStepIndex + 1;
  const percentage = ((currentStepIndex + 1) / totalSteps) * 100;
  
  return {
    currentStep: currentStepNumber,
    totalSteps,
    percentage: Math.min(percentage, 100)
  };
};